import React from "react";
import { TradeIdsToPnlMapping } from "@shared/services/socket/types";

export const SocketPnlContext = React.createContext<
  | {
      socketPnlValue?: TradeIdsToPnlMapping;
      useGlobalPnl?: boolean;
    }
  | undefined
>(undefined);
